import AppManager from "../../managers/AppManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import { CampaignService } from "../../services/campaign";
import Utility from "../../utility/Utility";
import { showLoader, removeLoader } from "deskera-ui-library";

import React from "react";
import CampaignPageHeader from "./CampaignPageHeader";
import TemplateManager from "./templates/TemplateManager";
import template_1 from "../../assets/campaignTemplates/Thumbnail-Newsletter-1.png";
import template_2 from "../../assets/campaignTemplates/Thumbnail-Newsletter-2.png";
import template_3 from "../../assets/campaignTemplates/Thumbnail-Newsletter-3.png";
import template_4 from "../../assets/campaignTemplates/Thumbnail-Newsletter-4.png";
import template_5 from "../../assets/campaignTemplates/Thumbnail-Newsletter-5.png";
import template_6 from "../../assets/campaignTemplates/Thumbnail-Newsletter-6.png";
import template_7 from "../../assets/campaignTemplates/Thumbnail-Newsletter-7.png";
import template_8 from "../../assets/campaignTemplates/Thumbnail-Newsletter-8.png";
import template_9 from "../../assets/campaignTemplates/Thumbnail-Newsletter-9.png";
import template_10 from "../../assets/campaignTemplates/Thumbnail-Newsletter-10.png";

import { showToast, TOAST_TYPE } from "deskera-ui-library";

export default class CampaignManager {
  static pageData = null;
  static templateData = null;
  static campaignId = null;

  static status = {
    DRAFT: [1],
    RUNNING: [2],
    SENT: [3],
    SCHEDULED: [4],
    CANCELED: [5],
    FAILED: [6],
    SCHEDULED_NOW: [7],
  };

  static campaignActivate = "Template Activated";
  static campaignSent = "Template Sent";
  static yourCampaignStarted = "Your template has started just now";
  static yourCampaignSent = "Your template has been sent";
  static yourCampaignActivatedAndStarted =
    "Your template has been activated and started successfully.";

  static getAllCreationSteps() {
    const pageId = CampaignManager.getCampaignId()
      ? "/" + CampaignManager.getCampaignId()
      : "";
    let steps = [
      {
        title:
          CampaignManager.isPageDataAvailable() &&
          !CampaignManager.checkCampaignSent()
            ? "Edit Design"
            : "Design",
        onClick: () => {
          if (CampaignManager.isPageDataAvailable()) {
            RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_BUILDER + pageId);
          } else {
            showToast("Please select template", TOAST_TYPE.FAILURE);
          }
        },
      },
      ////Will Remove in Future
      {
        title:
          CampaignManager.isPageDataAvailable() &&
          !CampaignManager.checkCampaignSent()
            ? "Edit Summary"
            : "Summary",
        onClick: () => {
          if (CampaignManager.isPageDataAvailable()) {
            RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_SUMMARY + pageId);
          } else {
            showToast("Please save design to proceed", TOAST_TYPE.FAILURE);
          }
        },
      },
      {
        title: CampaignManager.isPageDataAvailable()
          ? "Publish Details"
          : "Send",
        onClick: () => {
          if (
            CampaignManager.isPageDataAvailable() &&
            !this.checkCampaignInDraft()
          ) {
            RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_SUCCESS + pageId);
          } else {
            showToast("Please save summary to proceed", TOAST_TYPE.FAILURE);
          }
        },
      },
    ];
    const templateSelectionStep = {
      title:
        CampaignManager.isPageDataAvailable() &&
        !CampaignManager.checkCampaignSent()
          ? "Change Template"
          : "Select Template",
      onClick: () => {
        RouteManager.navigateToPage(
          PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE + pageId
        );
      },
    };
// will remove in future
    if (!CampaignManager.checkCampaignSent()) {
      steps.splice(0, 0, templateSelectionStep);
    }

    return steps;
  }

  static getTemplateHTMLData = () => {
    return this.templateData;
  };

  static setTemplateHTMLData = (data) => {
    this.templateData = data;
  };

  static getCampaignId = () => {
    if (!CampaignManager.isPageDataAvailable()) {
      return;
    }
    let campaignId = CampaignManager.pageData.id;
    return campaignId;
  };

  static setPageData(response) {
    this.pageData = response;
  }

  static getPageData() {
    return this.pageData || "";
  }
  static isPageDataAvailable() {
    return !(
      CampaignManager.pageData === null ||
      CampaignManager.pageData === undefined
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getRequestToSavePage(pageData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.NAME)] = pageData.name;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.CLICKS)] = 0;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.OPEN)] = 0;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.DELIVERED)] = 0;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.STATUS)] =
      CampaignManager.status.DRAFT;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.HTML_DATA)] = pageData.html;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.JSON_DATA)] = pageData.json;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.HASH)] = pageData.hash;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.PUBLISHED)] = false;
    return data;
  }

  static getRequestToUpdatePage(pageData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.NAME)] = pageData.name;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.HTML_DATA)] = pageData.html;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.JSON_DATA)] = pageData.json;
    return data;
  }

  static getColumnId(columnCode) {
    return TableManger.getColumnId(TABLES.CAMPAIGN, columnCode);
  }

  static getTableId() {
    return TableManger.getTableId(TABLES.CAMPAIGN);
  }

  static getRequestToPublishPage(pageData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.SEGMENT_ID)] =
      pageData.segmentId;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.EMAIL_SUBJECT)] =
      pageData.subject;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.EMAIL_PRE_HEADER)] =
      pageData.preHeaderText;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.STATUS)] = pageData.send_now
      ? CampaignManager.status.SCHEDULED_NOW
      : CampaignManager.status.SCHEDULED;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.PUBLISHED_ON)] =
      pageData.publish_on;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.EMAIL_FROM)] = pageData.from;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.PUBLISHED)] = true;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.SEND_NOW)] = pageData.send_now;
    data[this.getColumnId(COLUMN_CODE.CAMPAIGN.SMTP_SETUP_ID)] =
      pageData.smtp_setup_id;
    return data;
  }

  static getDirectLink() {
    if (this.pageData == null) {
      return;
    }
    let directLink = this.pageData.data.cells[
      CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.DIRECT_LINK)
    ];
    if (directLink.includes(window.location.origin)) {
      return directLink;
    } else {
      return AppManager.generateDirectLink(directLink);
    }
  }

  static directLinkExists() {
    if (this.pageData == null) {
      return false;
    }
    let directLink = this.pageData.data.cells[
      CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.DIRECT_LINK)
    ];
    return !Utility.isEmpty(directLink);
  }

  static getCampaignStatus = () => {
    if (!CampaignManager.isPageDataAvailable()) {
      return;
    }
    let status =
      CampaignManager.pageData.data.cells[
        this.getColumnId(COLUMN_CODE.CAMPAIGN.STATUS)
      ];
    return status;
  };

  static checkCampaignInDraft = () => {
    if (!CampaignManager.isPageDataAvailable()) {
      return false;
    }
    return (
      CampaignManager.status.DRAFT.toString() ===
      CampaignManager.getCampaignStatus().toString()
    );
  };

  static checkCampaignSent = () => {
    if (!CampaignManager.isPageDataAvailable()) {
      return false;
    }
    return (
      CampaignManager.status.SENT.toString() ===
      CampaignManager.getCampaignStatus().toString()
    );
  };

  static fetchPageDataById(id, callback) {
    showLoader("Fetching... Please wait");
    CampaignService.getData(id, CampaignManager.getTableId())
      .then((response) => {
        CampaignManager.setPageData({ data: response, id: response._id });
        callback && callback();
        removeLoader();
      })
      .catch((err) => {
        removeLoader();
      });
  }

  static setCampaignStatus = (status) => {
    let data = CampaignManager.getPageData();
    data.data.cells[this.getColumnId(COLUMN_CODE.CAMPAIGN.STATUS)] = status;
    CampaignManager.setPageData(data);
  };

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getHeader() {
    return <CampaignPageHeader title={"Email Templates"} stepperIndex={0} />;
  }

  static navigateToBuilder() {
    RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_BUILDER);
  }

  static setSelectedTemplateId(id) {
    TemplateManager.setSelectedTemplateId(id);
  }

  static getAllTemplates() {
    return [
      template_1,
      template_2,
      template_3,
      template_4,
      template_5,
      template_6,
      template_7,
      template_8,
      template_9,
      template_10,
    ];
  }

  static getSelectedTemplateId() {
    return TemplateManager.getSelectedTemplateId();
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
}
